(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cws-cart-actions"] && !Shopify.designMode) return;
  try {
    const cwsPendingForms = new WeakSet();
  let cwsAddQueue = Promise.resolve();
  const cwsSyncBuyButtons = () => {
    document.querySelectorAll('form[data-cws-cart-action="product"]').forEach((form) => {
      if (cwsPendingForms.has(form)) return;
      const add = form.querySelector('[ref="addToCartButton"]');
      const buy = form.querySelector('.cws-buy-now');
      if (add && buy && buy.disabled !== add.disabled) buy.disabled = add.disabled;
    });
  };
  const cwsVariantObserver = new MutationObserver(cwsSyncBuyButtons);
  cwsVariantObserver.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
  cwsSyncBuyButtons();
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-cws-cart-action]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (cwsPendingForms.has(form) || !form.reportValidity()) return;
    const submitter = event.submitter;
    const mainAdd = form.querySelector('[ref="addToCartButton"]');
    if (submitter?.disabled || mainAdd?.disabled) return;
    const messages = document.querySelector('[data-cws-cart-messages]')?.dataset;
    if (!messages) return;
    const status = form.querySelector('[data-cws-cart-status]');
    const data = new FormData(form);
    const component = form.closest('product-form-component');
    const quantitySelector = component?.querySelector('quantity-selector-component');
    const rule = quantitySelector?.canAddToCart?.();
    if (rule && !rule.canAdd) {
      if (status) { status.textContent = component.dataset.quantityErrorMax.replace(/\{\{\s*maximum\s*\}\}/, String(rule.maxQuantity)); status.dataset.error = 'true'; }
      return;
    }
    if (!data.get('id')) return;
    if (!data.get('quantity')) data.set('quantity', String(quantitySelector?.getValue?.() || component?.dataset.quantityDefault || 1));
    data.delete('return_to');
    const goToCart = submitter?.value === 'buy_now';
    const controls = [...form.querySelectorAll('button[type="submit"]')].map((button) => ({ button, disabled: button.disabled }));
    cwsPendingForms.add(form);
    form.setAttribute('aria-busy', 'true');
    controls.forEach(({ button }) => { button.disabled = true; });
    if (status) { status.textContent = messages.adding; delete status.dataset.error; }
    const add = async () => {
      const root = window.Shopify?.routes?.root || '/';
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data, credentials: 'same-origin' });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || messages.error);
        added = true;
        if (status) status.textContent = messages.added;
        try {
          const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            const updated = new Event('shopify:cart:lines-update', { bubbles: true });
            updated.action = 'add';
            updated.context = 'product';
            updated.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { items: cart.items, itemCount: cart.item_count, source: 'cws-cart-actions', didError: false } });
            form.dispatchEvent(updated);
          }
        } catch (_) {}
        if (goToCart) window.location.assign(messages.cartUrl || `${root}cart`);
      } catch (error) {
        if (!added && status) { status.textContent = error.message || messages.error; status.dataset.error = 'true'; }
      } finally {
        cwsPendingForms.delete(form);
        form.removeAttribute('aria-busy');
        controls.forEach(({ button, disabled }) => { button.disabled = disabled; });
        cwsSyncBuyButtons();
      }
    };
    cwsAddQueue = cwsAddQueue.then(add, add);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
